import { Phone, MessageCircle } from "lucide-react";
import { SITE, waLink } from "@/lib/content";

const WaIcon = () => <MessageCircle className="h-5 w-5" />;

export function StickyContact() {
  return (
    <>
      <div data-testid="sticky-mobile-bar" className="fixed inset-x-3 bottom-3 z-40 grid grid-cols-2 gap-2 rounded-full border border-forest/10 bg-cream/90 p-1.5 shadow-[0_20px_50px_-20px_rgba(36,64,42,0.55)] backdrop-blur-xl lg:hidden" style={{ paddingBottom: "max(0.375rem, env(safe-area-inset-bottom))" }}>
        <a href={`tel:${SITE.phoneTel}`} data-testid="sticky-call-button" className="flex items-center justify-center gap-2 rounded-full py-3 text-sm font-semibold text-forest">
          <Phone className="h-4 w-4" /> Call
        </a>
        <a href={waLink()} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp-button" className="flex items-center justify-center gap-2 rounded-full bg-forest py-3 text-sm font-semibold text-cream">
          <WaIcon /> WhatsApp
        </a>
      </div>
      <a
        href={waLink()}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat on WhatsApp"
        className="group fixed bottom-8 right-8 z-40 hidden items-center gap-3 rounded-full bg-forest py-3 pl-3 pr-5 text-sm font-semibold text-cream shadow-[0_20px_50px_-15px_rgba(20,83,45,0.7)] transition-transform duration-500 hover:-translate-y-1 lg:flex"
      >
        <span className="relative grid h-9 w-9 place-items-center rounded-full bg-leaf text-forest-deep">
          <span className="absolute inset-0 animate-ping rounded-full bg-leaf/50" />
          <WaIcon />
        </span>
        Chat with Sony
      </a>
    </>
  );
}
